import { BaseModel } from './base';

export class AdvancedSettings extends BaseModel {}
